import axios from "axios";

export const loginCall = async (userCredential, dispatch) => {
  dispatch({ type: "LOGIN_START" });
  try {
    const res = await axios.post(
      "https://millionaire-gules.vercel.app/api/user/register",
      userCredential
    );
    dispatch({ type: "LOGIN_SUCCESS", payload: res.data });
  } catch (err) {
    dispatch({ type: "LOGIN_FAILURE", payload: err });
  }
};

export const renderResult = (userInfo) => {
  try {
    axios.patch(
      "https://millionaire-gules.vercel.app/api/user/update",
      userInfo
    );
  } catch (err) {
    console.log(err);
  }
};

export const sendEmail = (info) => {
  try {
    axios.put(
      "https://millionaire-gules.vercel.app/api/user/update/email",
      info
    );
  } catch (err) {
    console.log(err);
  }
};
